import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=674e6128"
import script from "./ResultRow.vue?vue&type=script&lang=js"
export * from "./ResultRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports